<template>

  <div>
      <center><H3>Order History</H3></center>

      <v-toolbar-title>
          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
          ></v-text-field>
      </v-toolbar-title>

      <v-data-table
          class="table"
          :headers="order_headers"
          :items="order_t"
          :search="search"
          :rows-per-page-items="[10, 25]">
          <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.Date }}</td>
              <td class="text-xs-left">{{ props.item.Code }}</td>
              <td class="text-xs-left">{{ props.item.Item }}</td>
              <td class="text-xs-left">{{ props.item.freeitem }}</td>              
              <td class="text-xs-left">{{ props.item.Qty }}</td>
              <td class="text-xs-center">
                <v-icon class="mr-2" @click="del_prod(props.item.Date , props.item.Code , props.item.Qty , props.item.freeitem  )">delete</v-icon>
              </td>
          </template>
      </v-data-table>

  </div>

</template>

<script>
export default {
  data() {
    return {
            order_headers:[ 
              { text: 'Date', value: 'Date' },
              { text: 'Code', value: 'Code' },
              { text: 'Item', value: 'Item' },
              { text: 'free/addon', value: 'freeitem' },              
              { text: 'Qty', value: 'Qty' },
              { text: 'Actions', value: 'actions', align: 'center', sortable: false },
            ],
            credit_t: [],
            order_t: [],
            search: '',

    }
  },
    created () {
      console.log("CREATE")
      this.read_data()
  }, 
  methods :{
        read_data() {
            const vm = this;
            vm.axios.get('https://ws.plantifulbkk.shop/get_order_by_cust.php',{
                        params: {
                            scode: this.$store.getters.get_user_code ,
                        }
                    }).then(response => {
            var result = JSON.parse(JSON.stringify(response.data))
            vm.order_t = result
            console.log(vm.order_t)
            });
        },
        del_prod( date , code , qty , freeitem){

            const vm = this;
            vm.axios.get('https://ws.plantifulbkk.shop/post_del_order_hist_by_item.php',{
                params: {
                    scode: this.$store.getters.get_user_code ,
                    sdate : date ,
                    scode_item : code ,
                    sqty : qty , 
                    sfree : freeitem ,
                }
            }).then(response => {

              console.log(response.data)
              this.read_data()
            });

        },

  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/view_table_order_hist.vue